// extracted by mini-css-extract-plugin
export var label = "_4w-1";
export var reminder = "_4w-0";